import React from 'react'
import { Box, Button, Group } from '@mantine/core'
import { useEditMode } from './providers'
import { useWidgetEditor } from './state'
import { ActionOverlay } from './ActionOverlay'

export function ContainerWrapper({
  children,
  name,
  id,
  style,
  onCancel,
  onSave,
}: {
  children: React.ReactNode
  name: string
  id: string
  style?: React.CSSProperties
  onCancel: () => void
  onSave: () => void
}) {
  const [editMode] = useEditMode()
  const [isHovered, setIsHovered] = React.useState(false)
  const editor = useWidgetEditor()
  const isEdited = editor.useIsEditMode(id, null)

  const onReorder = editor.useEditCallback(id, 'reorder')
  const onAdd = editor.useEditCallback(id, 'add')
  const onRemove = editor.useEditCallback(id, 'remove')
  const onOptions = editor.useEditCallback(id, 'options')

  let border = '2px dashed transparent'
  if (isEdited) border = '2px solid #228be6'
  else if (isHovered) border = '2px dashed #228be6'

  if (!editMode) {
    return <>{children}</>
  } else {
    return (
      <Box
        style={{
          position: 'relative',
          border,
          borderRadius: '8px',
          transition: 'border-color 0.2s ease-in-out',
          ...style,
        }}
      >
        <Group
          justify="space-between"
          py={2}
          px="xs"
          style={{
            backgroundColor: '#f8f9fa',
            borderRadius: '6px 6px 0 0',
            cursor: 'pointer',
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div style={{ fontWeight: 500 }}>{name}</div>
          <Group gap="xs">
            {!isEdited && (
              <>
                <Button size="xs" variant="subtle" onClick={onOptions}>
                  Options
                </Button>
                <Button size="xs" variant="subtle" onClick={onReorder}>
                  Reorder
                </Button>
                <Button size="xs" variant="subtle" onClick={onAdd}>
                  Add
                </Button>
                <Button size="xs" variant="subtle" onClick={onRemove}>
                  Remove
                </Button>
              </>
            )}
            {isEdited && (
              <>
                <Button
                  size="xs"
                  color="red"
                  variant="subtle"
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button size="xs" onClick={onSave}>
                  Save
                </Button>
              </>
            )}
          </Group>
        </Group>
        <Box py={3}>{children}</Box>
        <ActionOverlay widgetId={id} container={true} />
      </Box>
    )
  }
}
